import { render, staticRenderFns } from "./InterfaceAvatarUpload.vue?vue&type=template&id=11ff5219&scoped=true"
import script from "./InterfaceAvatarUpload.vue?vue&type=script&lang=js"
export * from "./InterfaceAvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./InterfaceAvatarUpload.vue?vue&type=style&index=0&id=11ff5219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff5219",
  null
  
)

export default component.exports